export default "__VITE_ASSET__JoeC6zc___"